import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineLite, TweenLite} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";
import {TheCryptSoundConfig} from "../configs/TheCryptSoundConfig";
import {TheCrypt} from "../TheCrypt";
import {ScatterCounter} from "./ScatterCounter";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BitmapText} from "pixi.js";
import {TheCryptGameAssets} from "../TheCryptGameAssets";
import {TheCryptScatter} from "../symbols/TheCryptScatter";

export class TheCryptFreespinIntro extends PIXI.Container implements StageLayer {
    private _spine: PIXI.spine.Spine | null;
    private _spineContainer: PIXI.Sprite;
    private _button: ContinueButton;
    private _spins: BitmapText | null;
    private _clickCallback: () => void;

    constructor() {
        super();
        this.name = "FreespinIntro";
        this.init();
    }

    private onButtonClick(playClickSound: boolean): void {
        if (playClickSound) {
            TheCryptSoundManager.playSound(TheCryptSoundConfig.CONTINUE_BUTTON);
        }
        const hideFSIntroTL: TimelineLite = new TimelineLite();

        hideFSIntroTL.add([
            TweenLite.to(this, 0.2, {alpha: 0}),
            () => {
                TheCryptSoundManager.playAmbientLoop(0.1, `fs${Math.ceil(Math.random() * 2)}`);
                this._button.enable(false);
                this._clickCallback();
                this._clickCallback = () => {
                };
            }
        ]);

        hideFSIntroTL.add(() => {
            this.visible = false;
            this._spineContainer.removeChildren();
            if (this._spine) {
                this._spine!.destroy();
                this._spine = null;
            }
            if (this._spins) {
                this._spins!.destroy();
                this._spins = null;
            }
        });
    }

    public onResize(): void {
        if (!this.visible) {
            return;
        }
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 588);
            return;
        }
        this._button.position.set(360, Math.max(530, NolimitApplication.screenBounds.bottom - 210));
    }

    private init(): void {
        this._spineContainer = new PIXI.Sprite();
        this.addChild(this._spineContainer);
        this._spineContainer.position.set(360, 360);
        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick(true));
        this._button.position.set(360, 530);
        this._button.pivot.set(this._button.width * 0.5, 0);
        this._button.enable(false);
        this._button.alpha = 0;
        this.addChild(this._button);
        this.visible = false;
    }

    public show(callback: () => void, isReplay: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._button.alpha = 0;
        if (this._spine) {
            this._spine.destroy();
            this._spine = null;
        }

        if (this._spins) {
            this._spins.destroy();
            this._spine = null;
        }

        this._spine = new PIXI.spine.Spine(TheCrypt.assetLoader.getSpineAsset("FS_Intro"));
        this._spineContainer.addChild(this._spine);

        this._spins = new BitmapText("22", {
            fontName: TheCryptGameAssets.BITMAP_FONT_FS_SPINS,
            fontSize: 40
        });
        this._spins.visible = false;
        this._spins.text = `${TheCrypt.model.freespinsLeft}`;
        this._spins.letterSpacing = 2;
        this._spins.position.set(360 - this._spins.width * 0.5, 155);
        this._spins!.alpha = 0;
        this.addChild(this._spins);

        tl.add(() => {
            this._clickCallback = callback;
        });

        if (TheCrypt.model.gameData && TheCrypt.model.gameData.brokeTheBank) {
            this.onButtonClick(false);
        } else {
            if (TheCrypt.model.freespinTriggeredThisSpin) {
               // tl.add(TheCryptSoundManager.playSound("scatterFlash"), 1);
                ScatterCounter.allScatters.forEach((scatter: TheCryptScatter) => {
                    tl.add(scatter.playWin(), 0);
                });
            }

            tl.add([
                () => {
                    this._spins!.visible = true;
                    this.visible = true;
                    this.onResize();
                    this.alpha = 1;
                    TheCryptSoundManager.playFSIntroSound();
                    TheCrypt.keypadPlugin.hide();
                },
                TheCrypt.gameViewContainer.addDimmer(false),
                TweenLite.to(this._button, 0.4, {alpha: 1}),
                TweenLite.to(this._spins, 0.4, {alpha: 1, delay: 0.4}),
                new SpineTween(this._spine, 0, "start")
            ]);
            tl.add([
                () => {
                    this._spine!.state.setAnimation(0, "loop", true);
                    ScatterCounter.reset();
                    this._button.enable(true);
                }
            ]);
        }
        return tl;
    }
}